import { render } from "./ViewRequestHistory.vue?vue&type=template&id=7b29cc95"
import script from "./ViewRequestHistory.vue?vue&type=script&lang=js"
export * from "./ViewRequestHistory.vue?vue&type=script&lang=js"

import "./ViewRequestHistory.vue?vue&type=style&index=0&id=7b29cc95&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__